var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[(_vm.d_showCkEditor)?_c('b-card',[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.p_editorData.text),callback:function ($$v) {_vm.$set(_vm.p_editorData, "text", $$v)},expression:"p_editorData.text"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }